import styled from 'styled-components';
import {
    PlayerStatsWrapper,
    PlayerInfoWrapper
} from '@mlb/react-patterns/components/PlayerMatchup/playerMatchup.style';

export const PlayerDuelWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    margin: 0 auto;

    ${PlayerStatsWrapper} {
        font-size:  14px;
        color: var(--gameday-secondary-font-color);
        white-space: nowrap;
        height: 12px;
        margin-top: 4px;
        .before-list, .after-list {
            margin-top: 0px;
            display: inline-block;
        }

        
    }

    ${PlayerInfoWrapper} {
        height: 14px;
        justify-content: center;
    }

`;
